import {
  List,
  ListItem,
  Box,
} from '@mui/material';
import styled from '@emotion/styled';

export const UserMessage = styled(ListItem)({
  justifyContent: 'flex-end',
  textAlign: 'right',
});

export const BotMessage = styled(ListItem)({
  justifyContent: 'flex-start',
  textAlign: 'left',
});

export const MessageBubble = styled(Box)(({ theme }) => ({
  maxWidth: '70%',
  padding: '8px 12px',
  borderRadius: '12px',
  margin: '4px 0',
}));

export const UserBubble = styled(MessageBubble)(({ theme }) => ({
  // backgroundColor: theme.palette.primary.light,
  // color: theme.palette.primary.contrastText,
}));

export const BotBubble = styled(MessageBubble)(({ theme }) => ({
  // backgroundColor: theme.palette.grey[300],
}));
